;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["leaderboardservices"],
  data: function data() {
    return {
      services: []
    };
  },

  watch: {
    leaderboardservices: function leaderboardservices(val) {
      this.services = val;
    }
  },
  methods: {
    to_fixed: function to_fixed(val) {
      return (Math.round(val * 100) / 100).toFixed(2);
    },
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    to_human: function to_human(x) {
      if (x == null) return 0;
      var n = this.to_fixed(x);
      return this.formatNumber(n.toLocaleString());
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-nowrap card-table"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.services),function(item,index){return _c('tbody',{key:index},[_c('tr',[_c('td',[_c('strong',[_vm._v(_vm._s(item.service_name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatNumber(item.kes_customers)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatNumber(item.kes_applications)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(item.currency)+" "+_vm._s(_vm.to_human(item.kes_revenue))+"\n                  ")])])])})],2)])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-8 col-md-6"},[_c('br'),_vm._v(" "),_c('h4',[_vm._v("Payment Switch Bank Leader Board - Last 7 Days")]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v("List of the most popular banks by transaction value")])])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Customers")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Transfers")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"150"}},[_vm._v("Last 7 days Value")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-355560d0", __vue__options__)
  } else {
    hotAPI.reload("data-v-355560d0", __vue__options__)
  }
})()}